import { Order } from 'shared/types/cart';
import Link from 'components/gruenland/atoms/link';
import OrderData from 'components/gruenland/molecules/order/OrderData';
import { useFormat } from 'helpers/hooks/useFormat';

interface Props {
  order: Order;
  shippingInfo: string;
}

const OrderShippingDetails: React.FC<Props> = ({ order, shippingInfo }) => {
  const { formatMessage } = useFormat({ name: 'gruenland' });

  return (
    <>
      <OrderData
        label={formatMessage({
          id: 'order.deliveryMethod',
          defaultMessage: 'Metodo di spedizione',
        })}
        className="mt-2"
      >
        {shippingInfo}
      </OrderData>

      <OrderData
        label={formatMessage({
          id: 'order.shippingAddress',
          defaultMessage: 'Indirizzo di spedizione',
        })}
        className="mt-2"
      >
        <p>{`${order.shippingAddress?.firstName ?? ''} ${order.shippingAddress?.lastName ?? ''}`}</p>
        <p>{`${order.shippingAddress?.streetName}, ${order.shippingAddress?.city}, ${order.shippingAddress?.postalCode}`}</p>
        {order.shippingAddress?.additionalAddressInfo && <p>{order.shippingAddress?.additionalAddressInfo}</p>}
      </OrderData>

      {order.trackingUrl && (
        <OrderData
          label={formatMessage({
            id: 'order.trackingUrl',
            defaultMessage: 'Link di tracciamento',
          })}
          className="mt-2"
        >
          <Link link={order.trackingUrl} target="_blank">
            {order.trackingUrl}
          </Link>
        </OrderData>
      )}
    </>
  );
};

export default OrderShippingDetails;
